import React, {
  useState,
  useEffect
} from 'react';

import { makeStyles } from '@material-ui/core/styles';
import {
  Paper
} from '@material-ui/core';

import localization from '../../../utils/localizations';

import {
  Coordinate
} from '../../../types';

const appConfig = (window as any).APP_CONFIG;

const useStyles = makeStyles((theme) => ({
  root: {
    
  },
}));

interface StaticMapProps {
  location: Coordinate;
  zoom?: number;
  width?: number;
  height?: number;
  maptype?: string;
  imageClassName?: string;
}

function StaticMap(props: StaticMapProps) {
  const classes = useStyles();
  const zoom = props.zoom ? props.zoom : 13;
  const width = props.width ? props.width : 600;
  const height = props.height ? props.height : 300;
  const maptype = props.maptype ? props.maptype : "roadmap";

  return (
    <div className={classes.root}>
      <a href={`https://www.google.com/maps/search/?api=1&query=${props.location.latitude},${props.location.longitude}`} target="_blank">
        <img src={`https://maps.googleapis.com/maps/api/staticmap?center=${props.location.latitude},${props.location.longitude}&zoom=${zoom}&size=${width}x${height}&maptype=${maptype}&markers=${props.location.latitude},${props.location.longitude}&key=${appConfig.googleMapApiKey}`} alt="map" width={width} height={height} className={props.imageClassName} />
      </a>
    </div>
  );
}

export {StaticMap};